import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { endOfDay, parseJSON, startOfDay } from "date-fns";
import { Box, Button, CheckBox, DropButton, FormField, List, Text, TextInput } from "grommet";
import React from "react";
import { DateTimePicker } from "../components/DateTimePicker";
import StyledModal from "../components/StyledModal";
import * as CalendarStore from "./CalendarStore";

interface CreateEventProps {
    calendars: CalendarStore.CalendarViewModel[];
    onChange: (calendar: CalendarStore.CalendarViewModel) => void;
}

const CreateEventButton = ({ calendars, onChange }: CreateEventProps) => {
    const [showCreateEventModal, setShowCreateEventModal] = React.useState(false);

    const [eventName, setEventName] = React.useState("");
    const [startDate, setStartDate] = React.useState("");
    const [endDate, setEndDate] = React.useState("");
    const [allDayEvent, setAllDayEvent] = React.useState(false);
    const [currentEvent, setCurrentEvent] = React.useState({} as CalendarStore.CalendarEventViewModel);

    const startCreateEvent = () => {
        setShowCreateEventModal(true);
    };

    const [calendar, setCalendar] = React.useState(calendars.length > 0 ? calendars[0] : null);

    const createEvent = () => {
        if (calendar && calendar.id) {
            CalendarStore.CreateEvent({
                allDay: allDayEvent,
                calendarID: calendar.id,
                startDate: allDayEvent ? startOfDay(parseJSON(startDate)) : startDate,
                endDate: allDayEvent ? endOfDay(parseJSON(endDate)) : endDate,
                title: eventName,
                metadata: {},
            } as CalendarStore.CreateEventRequest).then((response) => {
                setShowCreateEventModal(false);
                setEventName("");
                setStartDate("");
                setEndDate("");
                setAllDayEvent(false);
                onChange(calendar);
            });
        }
    };

    const [open, setOpen] = React.useState(false);

    return (
        <>
            <DropButton
                as="div"
                open={open}
                onClose={() => setOpen(false)}
                dropContent={
                    <List
                        data={calendars}
                        onClickItem={(e) => {
                            setCalendar(e.item);
                            setOpen(false);
                        }}
                        primaryKey="name"
                    />
                }
            >
                <Box direction="row" gap="xsmall" align="center">
                    <Button onClick={() => startCreateEvent()} label={"New Event: " + calendar?.name} icon={<FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>}></Button>
                    {calendars.length > 1 && <Button onClick={() => setOpen(true)} label={<FontAwesomeIcon icon={["fad", "chevron-down"]}></FontAwesomeIcon>}></Button>}
                </Box>
            </DropButton>
            {/* <Button onClick={() => startCreateEvent()} label={"Create Event for " + calendar?.name} icon={<FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>}></Button> */}
            <StyledModal isOpen={showCreateEventModal}>
                <Box pad="small" width="medium">
                    <FormField label="Event Name">
                        <TextInput id="name" type="text" value={eventName} onChange={(e) => setEventName(e.target.value)}></TextInput>
                    </FormField>
                    <Box>
                        <Text>All Day Event</Text>
                        <CheckBox id="allDay" type="switch" checked={allDayEvent} onChange={(e) => setAllDayEvent(e.target.checked)}></CheckBox>
                    </Box>
                    <FormField label="Start Date">
                        <DateTimePicker value={startDate} onChange={setStartDate} hideTime={allDayEvent}></DateTimePicker>
                    </FormField>
                    <FormField label="End Date">
                        <DateTimePicker value={endDate} onChange={setEndDate} hideTime={allDayEvent}></DateTimePicker>
                    </FormField>

                    <Box direction="row" justify="end" gap="xsmall">
                        <Button secondary onClick={() => setShowCreateEventModal(false)} label="Close"></Button>
                        <Button primary onClick={() => createEvent()} disabled={!eventName} label="Create"></Button>
                    </Box>
                </Box>
            </StyledModal>
        </>
    );
};

export default CreateEventButton;
